/* Crest Grading — theme scripts */
(function () {
  'use strict';

  /* ---- mobile nav ---- */
  var burger = document.querySelector('[data-burger]');
  var mnav = document.querySelector('[data-mobile-nav]');
  if (burger && mnav) {
    burger.addEventListener('click', function () {
      var open = mnav.classList.toggle('is-open');
      burger.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  }

  /* ---- scan line sizing ---- */
  function fitScans() {
    document.querySelectorAll('[data-scan]').forEach(function (scan) {
      var host = scan.parentElement;
      if (host) scan.style.setProperty('--h', host.offsetHeight + 'px');
    });
  }
  fitScans();
  window.addEventListener('resize', fitScans);
  window.addEventListener('load', fitScans);

  /* ---- scroll reveals ---- */
  var reveals = document.querySelectorAll('.reveal');
  if (reveals.length && 'IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.06 });
    reveals.forEach(function (el) { io.observe(el); });
  } else {
    reveals.forEach(function (el) { el.classList.add('is-in'); });
  }

  /* ---- cert lookup ---- */
  document.querySelectorAll('[data-lookup]').forEach(function (form) {
    var input = form.querySelector('[data-cert-input]');
    var msg = form.querySelector('[data-lookup-msg]');
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (!input) return;
      var cert = (input.value || '').trim().toUpperCase().replace(/[^A-Z0-9-]/g, '');
      if (!cert) {
        if (msg) msg.textContent = 'Enter a certification number.';
        input.focus();
        return;
      }
      if (msg) msg.textContent = 'Searching\u2026';
      var base = form.getAttribute('data-lookup') || '/pages/verify';
      window.location.href = base + '?cert=' + encodeURIComponent(cert);
    });
  });

  /* ---- cert result rendering ---- */
  var vault = document.querySelector('[data-cert-vault]');
  if (vault) {
    var records = {};
    try { records = JSON.parse(vault.textContent || '{}'); } catch (e) { records = {}; }

    var sheetEl = document.querySelector('[data-cert-sheet]');
    var sheetUrl = sheetEl ? (sheetEl.getAttribute('data-cert-sheet') || '').trim() : '';

    var params = new URLSearchParams(window.location.search);
    var q = (params.get('cert') || '').trim().toUpperCase().replace(/[^A-Z0-9-]/g, '');

    var resultBox = document.querySelector('[data-cert-result]');
    var missBox = document.querySelector('[data-cert-miss]');
    var introBox = document.querySelector('[data-cert-intro]');
    var missNum = document.querySelector('[data-miss-num]');
    var loadMsg = document.querySelector('[data-lookup-msg]');
    var prefill = document.querySelector('[data-cert-input]');

    /* --- minimal RFC4180 CSV parser (handles quotes, commas, newlines) --- */
    function parseCSV(text) {
      var rows = [], row = [], field = '', i = 0, inQuotes = false;
      text = text.replace(/\r\n/g, '\n').replace(/\r/g, '\n');
      while (i < text.length) {
        var c = text[i];
        if (inQuotes) {
          if (c === '"') {
            if (text[i + 1] === '"') { field += '"'; i += 2; continue; }
            inQuotes = false; i++; continue;
          }
          field += c; i++; continue;
        }
        if (c === '"') { inQuotes = true; i++; continue; }
        if (c === ',') { row.push(field); field = ''; i++; continue; }
        if (c === '\n') { row.push(field); rows.push(row); row = []; field = ''; i++; continue; }
        field += c; i++;
      }
      if (field.length || row.length) { row.push(field); rows.push(row); }
      return rows;
    }

    /* --- map sheet headers to record keys, tolerant of naming --- */
    var HEADER_MAP = {
      cert: 'cert', certnumber: 'cert', certno: 'cert', certificate: 'cert', certificationnumber: 'cert',
      title: 'title', cardtitle: 'title', card: 'title',
      subtitle: 'subtitle',
      grade: 'grade', finalgrade: 'grade',
      gradeword: 'grade_word', gradewording: 'grade_word', gradelabel: 'grade_word',
      year: 'year',
      set: 'set', setname: 'set',
      player: 'player', subject: 'player',
      cardnumber: 'card_number', cardno: 'card_number', number: 'card_number',
      variety: 'variety', parallel: 'parallel',
      gradedon: 'graded_on', gradeddate: 'graded_on', date: 'graded_on',
      notes: 'notes', gradernotes: 'notes', notebook: 'notes',
      centering: 'centering', corners: 'corners', edges: 'edges', surface: 'surface',
      image: 'image', imageurl: 'image', photo: 'image'
    };

    function normHeader(h) {
      return (h || '').toLowerCase().replace(/[^a-z0-9]/g, '');
    }

    function rowsToRecords(rows) {
      if (!rows.length) return {};
      var headers = rows[0].map(function (h) { return HEADER_MAP[normHeader(h)] || null; });
      var out = {};
      for (var r = 1; r < rows.length; r++) {
        var rec = {};
        for (var c = 0; c < headers.length; c++) {
          if (headers[c]) rec[headers[c]] = (rows[r][c] || '').trim();
        }
        if (rec.cert) {
          rec.cert = rec.cert.toUpperCase();
          out[rec.cert] = rec;
        }
      }
      return out;
    }

    /* --- build a title from the detail columns when none is given --- */
    function composeTitle(rec) {
      if (rec.title) return rec.title;
      var parts = [rec.year, rec.set, rec.player, rec.card_number];
      var out = parts.filter(function (p) { return p && String(p).trim(); })
                     .map(function (p) { return String(p).trim(); });
      return out.length ? out.join(' ') : rec.cert;
    }

    /* --- generic varieties that add nothing on their own --- */
    var HIDE_VARIETY = ['base'];

    function shownVariety(rec) {
      var v = (rec.variety || '').trim();
      return HIDE_VARIETY.indexOf(v.toLowerCase()) === -1 ? v : '';
    }

    /* --- variety and parallel stand in as the subtitle when none is given --- */
    function composeSubtitle(rec) {
      if (rec.subtitle) {
        return { text: rec.subtitle, usedVariety: false, usedParallel: false };
      }
      var v = shownVariety(rec);
      var p = (rec.parallel || '').trim();
      var parts = [v, p].filter(Boolean);
      return {
        text: parts.join(' \u2014 '),
        usedVariety: !!v,
        usedParallel: !!p
      };
    }

    function showMiss(num) {
      if (missNum) missNum.textContent = num;
      if (introBox) introBox.classList.add('hide');
      if (resultBox) resultBox.classList.add('hide');
      if (missBox) missBox.classList.remove('hide');
      if (loadMsg) loadMsg.textContent = '';
    }

    function showHit(rec) {
      renderCert(rec);
      if (introBox) introBox.classList.add('hide');
      if (missBox) missBox.classList.add('hide');
      if (resultBox) resultBox.classList.remove('hide');
      if (loadMsg) loadMsg.textContent = '';
    }

    if (q) {
      if (prefill) prefill.value = q;

      if (records[q]) {
        showHit(records[q]);            // block override — instant, no fetch
      } else if (sheetUrl) {
        if (loadMsg) loadMsg.textContent = 'Searching the database\u2026';
        fetch(sheetUrl, { cache: 'no-store' })
          .then(function (r) {
            if (!r.ok) throw new Error('HTTP ' + r.status);
            return r.text();
          })
          .then(function (text) {
            var fromSheet = rowsToRecords(parseCSV(text));
            if (fromSheet[q]) showHit(fromSheet[q]);
            else showMiss(q);
          })
          .catch(function () {
            showMiss(q);
            if (loadMsg) {
              loadMsg.textContent = 'Could not reach the cert database. Check the sheet URL in the theme editor.';
            }
          });
      } else {
        showMiss(q);
        if (loadMsg) {
          loadMsg.textContent = 'No cert database connected. Add your Google Sheet CSV URL in the theme editor.';
        }
      }
    }

    function setText(sel, value) {
      document.querySelectorAll(sel).forEach(function (el) {
        el.textContent = value == null ? '' : value;
      });
    }
    function toggleRow(sel, value) {
      document.querySelectorAll(sel).forEach(function (el) {
        el.classList.toggle('hide', !value);
      });
    }

    function renderCert(r) {
      var title = composeTitle(r);
      var sub = composeSubtitle(r);

      document.title = title + ' \u2014 Cert ' + r.cert;
      setText('[data-f-title]', title);
      setText('[data-f-subtitle]', sub.text);
      setText('[data-f-cert]', r.cert);
      setText('[data-f-grade]', r.grade);
      setText('[data-f-gradeword]', r.grade_word);
      setText('[data-f-year]', r.year);
      setText('[data-f-set]', r.set);
      setText('[data-f-player]', r.player);
      setText('[data-f-cardnum]', r.card_number);
      setText('[data-f-variety]', shownVariety(r));
      setText('[data-f-parallel]', r.parallel);
      setText('[data-f-date]', r.graded_on);
      setText('[data-f-notes]', r.notes);

      toggleRow('[data-row-year]', r.year);
      toggleRow('[data-row-set]', r.set);
      toggleRow('[data-row-player]', r.player);
      toggleRow('[data-row-cardnum]', r.card_number);
      // don't repeat anything below that's already in the subtitle
      toggleRow('[data-row-variety]', shownVariety(r) && !sub.usedVariety);
      toggleRow('[data-row-parallel]', r.parallel && !sub.usedParallel);
      toggleRow('[data-row-date]', r.graded_on);
      toggleRow('[data-notes-wrap]', r.notes);
      toggleRow('[data-f-subtitle]', sub.text);

      var subs = [['centering', r.centering], ['corners', r.corners], ['edges', r.edges], ['surface', r.surface]];
      var anySub = false;
      subs.forEach(function (pair) {
        var el = document.querySelector('[data-sub="' + pair[0] + '"]');
        if (!el) return;
        if (pair[1]) {
          anySub = true;
          el.classList.remove('hide');
          var v = el.querySelector('[data-sub-val]');
          var bar = el.querySelector('[data-sub-bar]');
          if (v) v.textContent = pair[1];
          if (bar) bar.style.width = Math.max(0, Math.min(100, (parseFloat(pair[1]) / 10) * 100)) + '%';
        } else {
          el.classList.add('hide');
        }
      });
      toggleRow('[data-subs-wrap]', anySub);

      var img = document.querySelector('[data-f-image]');
      var imgWrap = document.querySelector('[data-f-image-wrap]');
      var head = document.querySelector('[data-cert-head]');
      if (img && r.image) {
        img.src = r.image;
        img.alt = r.title || r.cert;
        if (imgWrap) imgWrap.classList.remove('hide');
        if (head) head.classList.remove('cert-head--noimage');
      } else {
        if (imgWrap) imgWrap.classList.add('hide');
        if (head) head.classList.add('cert-head--noimage');
      }

      document.querySelectorAll('[data-copy-cert]').forEach(function (b) {
        b.setAttribute('data-copy', r.cert);
      });

      window.dispatchEvent(new Event('resize'));
    }
  }

  /* ---- quantity steppers ---- */
  document.querySelectorAll('[data-qty]').forEach(function (box) {
    var input = box.querySelector('input');
    box.querySelectorAll('button').forEach(function (b) {
      b.addEventListener('click', function () {
        var step = b.getAttribute('data-step') === 'up' ? 1 : -1;
        var min = parseInt(input.getAttribute('min') || '1', 10);
        var next = (parseInt(input.value, 10) || min) + step;
        input.value = next < min ? min : next;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
    });
  });

  /* ---- product variant picker ---- */
  var picker = document.querySelector('[data-variants]');
  if (!picker) {
    // no variants set up yet — hide the tier-driven bits so nothing renders empty
    document.querySelectorAll('[data-turnaround],[data-tier-points]').forEach(function (el) {
      el.style.display = 'none';
    });
  }
  if (picker) {
    var data = {};
    try { data = JSON.parse(picker.getAttribute('data-variants')); } catch (e) { data = {}; }
    var idField = document.querySelector('[data-variant-id]');
    var priceEl = document.querySelector('[data-price]');
    var wasEl = document.querySelector('[data-price-was]');
    var submit = document.querySelector('[data-buy]');
    var chosen = [];

    picker.querySelectorAll('[data-opt-group]').forEach(function (group, gi) {
      var active = group.querySelector('[aria-pressed="true"]');
      chosen[gi] = active ? active.getAttribute('data-value') : null;
      group.querySelectorAll('.swatch').forEach(function (sw) {
        sw.addEventListener('click', function () {
          group.querySelectorAll('.swatch').forEach(function (o) { o.setAttribute('aria-pressed', 'false'); });
          sw.setAttribute('aria-pressed', 'true');
          chosen[gi] = sw.getAttribute('data-value');
          sync();
        });
      });
    });

    var tiers = {};
    var tierEl = document.querySelector('[data-tier-details]');
    if (tierEl) { try { tiers = JSON.parse(tierEl.textContent || '{}'); } catch (e) { tiers = {}; } }
    var turnEl = document.querySelector('[data-turnaround]');
    var pointsEl = document.querySelector('[data-tier-points]');

    var qtyInput = document.querySelector('[data-qty] input');
    var qtyWarn = document.querySelector('[data-qty-warn]');
    var currentMin = 1;

    function enforceMin() {
      if (!qtyInput) return true;
      var qty = parseInt(qtyInput.value, 10) || 0;
      var ok = qty >= currentMin;
      if (qtyWarn) {
        if (ok) {
          qtyWarn.classList.add('hide');
          qtyWarn.textContent = '';
        } else {
          qtyWarn.classList.remove('hide');
          qtyWarn.textContent = 'This tier has a ' + currentMin + '-card minimum. Add ' +
            (currentMin - qty) + ' more, or switch to Standard.';
        }
      }
      if (submit) {
        if (!ok) {
          submit.setAttribute('aria-disabled', 'true');
          submit.textContent = currentMin + '-card minimum';
        }
      }
      return ok;
    }

    if (qtyInput) {
      qtyInput.addEventListener('input', function () { syncTier(); sync(); });
      qtyInput.addEventListener('change', function () { syncTier(); sync(); });
    }

    var buyForm = document.querySelector('.product__info form');
    if (buyForm) {
      buyForm.addEventListener('submit', function (e) {
        if (!enforceMin()) {
          e.preventDefault();
          if (qtyInput) qtyInput.focus();
        }
      });
    }

    function syncTier() {
      var t = tiers[chosen[0]];
      currentMin = t && t.min ? t.min : 1;
      if (qtyInput) qtyInput.setAttribute('min', currentMin);

      var kicker = document.querySelector('[data-kicker]');
      if (kicker) {
        kicker.textContent = chosen[0]
          ? chosen[0] + ' grading service'
          : 'Grading service';
      }

      if (turnEl) {
        turnEl.textContent = t && t.turnaround ? t.turnaround : '';
        turnEl.style.display = t && t.turnaround ? '' : 'none';
      }
      if (pointsEl) {
        pointsEl.innerHTML = '';
        var list = (t && t.points ? t.points : '').split(';');
        list.forEach(function (item) {
          var txt = item.trim();
          if (!txt) return;
          var li = document.createElement('li');
          li.textContent = txt;
          pointsEl.appendChild(li);
        });
        pointsEl.style.display = pointsEl.children.length ? '' : 'none';
      }
    }

    function sync() {
      syncTier();
      var key = chosen.join(' / ');
      var v = data[key];
      if (!v) {
        if (submit) { submit.setAttribute('aria-disabled', 'true'); submit.textContent = 'Unavailable'; }
        return;
      }
      if (idField) idField.value = v.id;
      if (priceEl) priceEl.textContent = v.price;
      if (wasEl) {
        wasEl.textContent = v.compare || '';
        wasEl.style.display = v.compare ? '' : 'none';
      }
      if (submit) {
        if (v.available) {
          submit.setAttribute('aria-disabled', 'false');
          submit.textContent = submit.getAttribute('data-label') || 'Add to cart';
        } else {
          submit.setAttribute('aria-disabled', 'true');
          submit.textContent = 'Sold out';
        }
      }
      enforceMin();
    }
    sync();
  }
})();

/* ============================================
   Grade generator — Crest Grading Standard v2.0
   Four pillars, averaged, rounded (.5 up), then capped.
   ============================================ */
(function () {
  'use strict';

  /* half points exist from 2.0 up; there is no 1.5 */
  var VALUES = [1, 2, 2.5, 3, 3.5, 4, 4.5, 5, 5.5, 6, 6.5, 7, 7.5, 8, 8.5, 9, 9.5, 10];

  var NAMES = {
    10: 'Gem Mint',
    9:  'Mint',
    8:  'Near Mint-Mint',
    7:  'Near Mint',
    6:  'Excellent-Mint',
    5:  'Excellent',
    4:  'Very Good-Excellent',
    3:  'Very Good',
    2:  'Good',
    1:  'Poor'
  };

  var KEYS = ['centering', 'corners', 'edges', 'surface'];

  function fmt(n) {
    return n % 1 === 0 ? String(n) : n.toFixed(1);
  }

  /* the standard, in order: average -> round -> caps (caps only ever lower) */
  function calculate(scores, armsLength) {
    var sum = scores.reduce(function (a, b) { return a + b; }, 0);
    var avg = sum / 4;
    var grade = Math.round(avg);              // an average ending in .5 rounds up
    var low = Math.min.apply(null, scores);
    var note = '';

    if (grade >= 10 && low < 9) {
      grade = 9;
      note = 'Gem Mint gate — a pillar at ' + fmt(low) + ' blocks a 10.';
    }

    var twoPoint = Math.floor(low + 2);
    if (grade > twoPoint) {
      grade = twoPoint;
      note = 'Two-point rule — the grade cannot sit more than 2 above the lowest pillar (' + fmt(low) + ').';
    }

    if (armsLength && grade > 8) {
      grade = 8;
      note = "Arm's-length rule — a defect visible without magnification caps the card at 8.";
    }

    if (grade < 1) grade = 1;

    return {
      avg: avg,
      low: low,
      grade: grade,
      note: note,
      perfect: scores.every(function (v) { return v === 10; })
    };
  }

  function build(root) {
    var ranges = {};
    var outs = {};

    KEYS.forEach(function (k) {
      ranges[k] = root.querySelector('[data-gg-range="' + k + '"]');
      outs[k] = root.querySelector('[data-gg-out="' + k + '"]');
    });
    if (!ranges.centering) return;

    var arms = root.querySelector('[data-gg-arms]');
    var elGrade = root.querySelector('[data-gg-grade]');
    var elWord = root.querySelector('[data-gg-word]');
    var elAvg = root.querySelector('[data-gg-avg]');
    var elLow = root.querySelector('[data-gg-low]');
    var elNote = root.querySelector('[data-gg-note]');
    var elCrest = root.querySelector('[data-gg-crest]');

    /* tick marks — taller on the whole numbers */
    root.querySelectorAll('[data-gg-ticks]').forEach(function (holder) {
      var frag = document.createDocumentFragment();
      VALUES.forEach(function (v) {
        var t = document.createElement('i');
        if (v % 1 === 0) t.className = 'is-whole';
        frag.appendChild(t);
      });
      holder.appendChild(frag);
    });

    function paint() {
      var scores = KEYS.map(function (k) {
        return VALUES[parseInt(ranges[k].value, 10)];
      });

      KEYS.forEach(function (k, i) {
        outs[k].textContent = fmt(scores[i]);
        ranges[k].setAttribute('aria-valuetext', fmt(scores[i]));
        /* fill the track up to the notch */
        var pct = (parseInt(ranges[k].value, 10) / (VALUES.length - 1)) * 100;
        ranges[k].style.setProperty('--fill', pct + '%');
        outs[k].classList.toggle('is-half', scores[i] % 1 !== 0);
      });

      var r = calculate(scores, arms && arms.checked);

      elGrade.textContent = r.grade;
      elWord.textContent = NAMES[r.grade] || '';
      elAvg.textContent = r.avg.toFixed(3);
      elLow.textContent = fmt(r.low);

      elNote.textContent = r.note;
      elNote.classList.toggle('is-capped', !!r.note);

      /* the perfect-four award, subject to a centering measurement we can't take here */
      if (elCrest) elCrest.hidden = !(r.perfect && !(arms && arms.checked));

      root.classList.toggle('is-ten', r.grade === 10);
    }

    KEYS.forEach(function (k) {
      ranges[k].addEventListener('input', paint);
      ranges[k].addEventListener('change', paint);
    });
    if (arms) arms.addEventListener('change', paint);

    paint();
  }

  document.querySelectorAll('[data-gg]').forEach(build);
})();

/* ============================================================
   Return-shipment insurance
   Reads the coverage bands emitted by the product template,
   quotes live as the customer types, and adds the matching
   insurance variant alongside the grading item on submit.
   Degrades to a plain form post if anything is missing.
   ============================================================ */
(function () {
  var root = document.querySelector('[data-ins-root]');
  if (!root) return;

  var bands = [];
  try { bands = JSON.parse(root.getAttribute('data-ins-bands') || '[]'); } catch (e) { bands = []; }
  bands = bands.filter(function (b) { return b && b.cap > 0; })
               .sort(function (a, b) { return a.cap - b.cap; });

  var FREE    = parseFloat(root.getAttribute('data-ins-free')) || 100;
  var SHIP    = parseFloat(root.getAttribute('data-ins-ship')) || 14.99;
  var ADD_URL = (root.getAttribute('data-cart-add') || '/cart/add') + '.js';
  var CART_URL= root.getAttribute('data-cart-url') || '/cart';
  var SUPPORT = root.getAttribute('data-support') || '';
  var MAXCAP  = bands.length ? bands[bands.length - 1].cap : 0;

  var input  = root.querySelector('#prop-value');
  var quote  = root.querySelector('[data-ins-quote]');
  var lineEl = root.querySelector('[data-ins-line]');
  var labEl  = root.querySelector('[data-ins-label]');
  var amtEl  = root.querySelector('[data-ins-amount]');
  var totEl  = root.querySelector('[data-ins-total]');
  var errEl  = root.querySelector('[data-ins-err]');
  var form   = root.closest('form');
  if (!input || !form) return;

  function group(s) { return s.replace(/\B(?=(\d{3})+(?!\d))/g, ','); }
  function money(n) { return '$' + group(n.toFixed(2)); }
  function moneyShort(n) {
    return '$' + group(n % 1 === 0 ? String(n) : n.toFixed(2));
  }
  function val() {
    var v = parseFloat(String(input.value).replace(/[^0-9.]/g, ''));
    return isFinite(v) ? v : NaN;
  }
  function band(v) {
    if (!bands.length || !isFinite(v) || v <= FREE) return null;
    for (var i = 0; i < bands.length; i++) if (bands[i].cap >= v) return bands[i];
    return null; // above the top band — needs a custom quote
  }
  function showErr(msg, mailto) {
    if (!errEl) return;
    errEl.textContent = msg;
    if (mailto && SUPPORT) {
      var a = document.createElement('a');
      a.href = 'mailto:' + SUPPORT + '?subject=' +
        encodeURIComponent('High-value submission quote');
      a.textContent = SUPPORT;
      errEl.appendChild(document.createTextNode(' '));
      errEl.appendChild(a);
    }
    errEl.classList.remove('hide');
  }
  function clearErr() {
    if (!errEl) return;
    errEl.textContent = '';
    errEl.classList.add('hide');
  }

  function render() {
    var v = val();
    if (!isFinite(v) || v <= 0) { if (quote) quote.classList.add('hide'); clearErr(); return; }

    if (bands.length && v > MAXCAP) {
      if (quote) quote.classList.add('hide');
      showErr('We insure up to ' + moneyShort(MAXCAP) +
              ' online. For a higher declared value, email us for a quote:', true);
      return;
    }
    clearErr();
    if (!quote) return;

    var b = band(v);
    var ins = b ? b.price / 100 : 0;
    quote.classList.remove('hide');
    if (lineEl) lineEl.style.display = b ? '' : 'none';
    if (b) {
      if (labEl) labEl.textContent = '(' + b.label + ')';
      if (amtEl) amtEl.textContent = money(ins);
    }
    if (totEl) totEl.textContent = money(SHIP + ins);
  }

  if (!bands.length && window.console && console.warn) {
    console.warn('[Crest] No insurance coverage bands found. The submission page will charge ' +
                 'flat shipping for every declared value. Import the insurance product and pick it ' +
                 'under Theme settings > Shipping insurance.');
  }

  input.addEventListener('input', render);
  input.addEventListener('change', render);
  render();

  function props() {
    var out = {};
    form.querySelectorAll('[name^="properties["]').forEach(function (el) {
      var m = el.getAttribute('name').match(/^properties\[(.+)\]$/);
      if (m && String(el.value).trim() !== '') out[m[1]] = el.value;
    });
    return out;
  }

  form.addEventListener('submit', function (e) {
    if (e.defaultPrevented) return;          // an earlier check already blocked it

    var v = val();
    if (!isFinite(v) || v <= 0) {
      e.preventDefault();
      showErr("Enter the total value of the cards you're sending.");
      input.focus();
      return;
    }
    if (bands.length && v > MAXCAP) {
      e.preventDefault();
      render();
      input.focus();
      return;
    }

    var b = band(v);
    if (!b) return;                          // at or under the free tier — normal post

    e.preventDefault();

    var idField = form.querySelector('[data-variant-id]');
    var qtyField = form.querySelector('[data-qty] input');
    var buy = form.querySelector('[data-buy]');
    if (!idField || !idField.value) { form.submit(); return; }

    var items = [
      { id: Number(idField.value), quantity: parseInt(qtyField && qtyField.value, 10) || 1, properties: props() },
      { id: Number(b.id), quantity: 1, properties: { 'Covers declared value': money(v) } }
    ];

    var restore = buy ? buy.textContent : '';
    if (buy) { buy.setAttribute('aria-disabled', 'true'); buy.textContent = 'Adding…'; }

    fetch(ADD_URL, {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: items })
    })
      .then(function (r) {
        if (!r.ok) throw new Error('add failed');
        window.location.href = CART_URL;
      })
      .catch(function () {
        if (buy) { buy.removeAttribute('aria-disabled'); buy.textContent = restore; }
        form.submit();                        // plain post, no submit event, no loop
      });
  });
})();

/* ============================================================
   Card list builder
   Progressive enhancement over the plain textarea: type one
   card, press Next (or Enter), it moves into a numbered list.
   The textarea stays in the DOM as the real form field so the
   page still works with JS off.
   ============================================================ */
(function () {
  var field = document.querySelector('[data-cardlist-field]');
  if (!field) return;
  var wrap = field.closest('.opt');
  if (!wrap) return;

  var entries = String(field.value || '')
    .split('\n').map(function (s) { return s.trim(); })
    .filter(Boolean);

  // --- build UI -------------------------------------------------
  var ui = document.createElement('div');
  ui.className = 'cl';
  ui.innerHTML =
    '<div class="cl__row">' +
      '<input type="text" class="input cl__input" autocomplete="off"' +
      ' aria-label="Card description" placeholder="Year, set, player, card number">' +
      '<button type="button" class="cl__add">Next</button>' +
    '</div>' +
    '<ol class="cl__list" aria-live="polite"></ol>' +
    '<p class="cl__count"></p>';
  field.parentNode.insertBefore(ui, field.nextSibling);

  var input = ui.querySelector('.cl__input');
  var addBtn = ui.querySelector('.cl__add');
  var list = ui.querySelector('.cl__list');
  var count = ui.querySelector('.cl__count');

  field.classList.add('hide');           // textarea becomes the hidden source of truth
  field.setAttribute('tabindex', '-1');
  field.setAttribute('aria-hidden', 'true');

  var qtyInput = document.querySelector('[data-qty] input');

  function sync() {
    field.value = entries.join('\n');
  }

  function render() {
    list.innerHTML = '';
    entries.forEach(function (text, i) {
      var li = document.createElement('li');
      li.className = 'cl__item';
      var span = document.createElement('span');
      span.className = 'cl__text';
      span.textContent = text;
      var del = document.createElement('button');
      del.type = 'button';
      del.className = 'cl__del';
      del.setAttribute('aria-label', 'Remove ' + text);
      del.innerHTML = '&times;';
      del.addEventListener('click', function () {
        entries.splice(i, 1);
        sync(); render();
        input.focus();
      });
      li.appendChild(span);
      li.appendChild(del);
      list.appendChild(li);
    });

    var n = entries.length;
    if (!n) {
      count.textContent = '';
      count.classList.remove('is-warn');
    } else {
      var qty = qtyInput ? (parseInt(qtyInput.value, 10) || 0) : 0;
      var base = n + (n === 1 ? ' card listed' : ' cards listed');
      if (qty && n !== qty) {
        count.textContent = base + ' · you selected ' + qty +
          (qty === 1 ? ' card' : ' cards') + ' above';
        count.classList.add('is-warn');
      } else {
        count.textContent = base;
        count.classList.remove('is-warn');
      }
    }
    sync();
  }

  function add(raw) {
    var parts = String(raw).split(/[\r\n]+/);   // a pasted block becomes several entries
    var added = 0;
    parts.forEach(function (p) {
      var t = p.trim();
      if (t) { entries.push(t); added++; }
    });
    if (added) { input.value = ''; render(); }
    input.focus();
  }

  addBtn.addEventListener('click', function () { add(input.value); });

  input.addEventListener('keydown', function (e) {
    if (e.key === 'Enter') { e.preventDefault(); add(input.value); }
  });

  input.addEventListener('paste', function (e) {
    var text = (e.clipboardData || window.clipboardData).getData('text');
    if (text && /[\r\n]/.test(text)) { e.preventDefault(); add(text); }
  });

  if (qtyInput) {
    qtyInput.addEventListener('input', render);
    qtyInput.addEventListener('change', render);
  }

  render();
})();
